<template>
    <div style="display: flex; flex-direction: column; gap: 50px; margin-top: 16px">
        <div class="large-checkbox">
            <el-checkbox :label="optionLabel" v-model="tab_form.is_active" @change="setOptionPrice"></el-checkbox>
        </div>

        <template v-if="tab_form.is_active">
            <el-row :gutter="20" style="font-size: 1.3em; margin: 10px 0;">
                <template v-for="(equipmentBasedPlan, index) in tab_form.equipment_based_plans">
                    <proposal-tab-pricing-option-ja
                        :equipment_based_plan="equipmentBasedPlan"
                        :index="index"
                        :key="index"
                    />
                </template>
            </el-row>

            <el-row :gutter="20" style="font-size: 1.3em; margin: 10px 0;">
                <el-col :span="8">
                    <h2>COMPANY DRIVER MULTI-CARRIER</h2>
                    <template v-if="results.display_driverboost_cd">
                        <p>Available: {{ results.mc_available.count_cd }} at ${{ results.mc_plans.cd[0].price }}/each</p>

                        <el-radio-group :value="mc_leads" @input="setMcLeads">
                            <div v-for="(plan, index) in results.mc_plans.cd" :key="index">
                                <el-radio :label="plan.leads">{{ plan.name }} <span v-if="plan.monthly_price > 0">(+ {{ money(plan.monthly_price, 0) }})</span></el-radio><br>
                            </div>
                            <div>
                                <el-radio label="custom">
                                <el-input v-model="custom_mc_cd_leads" style="width: 100px;" /> leads
                                <template v-if="custom_mc_cd_leads">
                                    (+ {{ money(parseInt(custom_mc_cd_leads) * mc_lead_price, 0) }})
                                </template>
                                </el-radio><br>
                            </div>
                        </el-radio-group>
                    </template>
                </el-col>
                <el-col :span="8">
                    <h2>OO &amp; LEASE PURCHASE MULTI-CARRIER</h2>

                    <template  v-if="results.display_driverboost_oo">
                        <p>Available: {{ results.mc_available.count_oo }} at ${{ results.mc_plans.oo[0].price }}/each</p>

                    <el-radio-group :value="mc_oo_leads" @input="setMcOOLeads">
                            <div v-for="(plan, index) in results.mc_plans.oo" :key="index">
                                <el-radio :label="plan.leads">{{ plan.name }} <span v-if="plan.monthly_price > 0">(+ {{ money(plan.monthly_price, 0) }})</span></el-radio><br>
                            </div>
                        <div>
                            <el-radio label="custom">
                                <el-input v-model="custom_mc_oo_leads" style="width: 100px;" /> leads
                                <template v-if="custom_mc_oo_leads">
                                    (+ {{ money(parseInt(custom_mc_oo_leads) * mc_oo_lead_price, 0) }})
                                </template>
                            </el-radio><br>
                        </div>
                        </el-radio-group>
                    </template>
                </el-col>
                <el-col :span="8">
                    <h2>INEXPERIENCED DRIVER MULTI-CARRIER</h2>

                    <template  v-if="results.display_driverboost_student">
                        <p>Available: {{ results.mc_available.count_student }} at ${{ results.mc_plans.student[0].price }}/each</p>

                        <el-radio-group :value="mc_student_leads" @input="setMcStudentLeads">
                            <div v-for="(plan, index) in results.mc_plans.student" :key="index">
                                <el-radio :label="plan.leads">{{ plan.name }} <span v-if="plan.monthly_price > 0">(+ {{ money(plan.monthly_price, 0) }})</span></el-radio><br>
                            </div>
                            <div>
                                <el-radio label="custom">
                                    <el-input v-model="custom_mc_student_leads" style="width: 100px;" /> leads
                                    <template v-if="custom_mc_student_leads">
                                        (+ {{ money(parseInt(custom_mc_student_leads) * mc_student_lead_price, 0) }})
                                    </template>
                                </el-radio><br>
                            </div>
                        </el-radio-group>
                    </template>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="24">
                    <h2>CUSTOM BUDGET</h2>
                    <el-checkbox v-model="tab_form.is_custom_budget_active">
                        <el-input v-model="tab_form.custom_budget" type="number" style="width:250px;">
                            <template slot="prepend">$</template>
                        </el-input>
                    </el-checkbox>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="24">
                    <h2>DISCOUNTS</h2>
                    <el-checkbox v-model="tab_form.discounts_250_ja" :disabled="tab_form.discounts_500_ja || tab_form.discounts_1000_ja">
                    <b v-if="discounts_250_ja_allowed">Suggested: </b>
                    Discount $250 Waive JB fee with purchase of 10 JA leads
                    </el-checkbox><br>
                    <el-checkbox v-model="tab_form.discounts_500_ja" :disabled="tab_form.discounts_250_ja || tab_form.discounts_1000_ja">
                    <b v-if="discounts_500_ja_allowed">Suggested: </b>
                    Discount $500 Waive JB fee with purchase of 25 JA leads
                    </el-checkbox><br>
                    <el-checkbox v-model="tab_form.discounts_1000_ja" :disabled="tab_form.discounts_250_ja || tab_form.discounts_500_ja">
                    <b v-if="discounts_1000_ja_allowed">Suggested: </b>
                    Discount $1000 Waive JB fee with purchase of $2,500+ in JA or MC
                    </el-checkbox><br>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="24">
                    <h2>TOTAL: {{ money(total) }}</h2>

                    <p>Gets uncapped job board, {{ allDejaLeads == 0 ? 'no' : allDejaLeads }} DEJA leads, {{ allMcLeads == 0 ? 'no' : allMcLeads }} MC.</p>

                    <p v-if="hireEstimate == 0">No hire estimate.</p>
                    <p v-if="hireEstimate > 0">Estimated hires: {{ hireEstimate }} per month.</p>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="12">
                    <h2>OPTION TEXT</h2>
                    <froala tag="textarea" :config="froalaConfig" v-model="tab_form.description" />
                </el-col>
                <el-col :span="12">
                    <proposal-preview-pricing-option
                        :form_data="form_data"
                        :number="number"
                    />
                </el-col>
            </el-row>
        </template>
    </div>
</template>

<script>
import ProposalTabPricingOptionJa from './proposal-tab-pricing-option-ja.vue';
import ProposalPreviewPricingOption from './../preview/proposal-preview-pricing-option.vue';

export default {
    components: {
        ProposalTabPricingOptionJa,
        ProposalPreviewPricingOption,
    },
    props: {
        proposal: {
            type: Object,
            required: true
        },
        tab_form: {
            type: Object,
            required: true
        },
        form_data: {
            type: Object,
            required: true
        },
        results: {
            type: Object,
            required: true
        },
        number: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            loading: false,

            custom_mc_cd_leads: this.tab_form.mc_leads,
            custom_mc_oo_leads: this.tab_form.mc_oo_leads,
            custom_mc_student_leads: this.tab_form.mc_student_leads,

            froalaConfig: {
                key: 'CA4D4A2D3E1D2tA6B4B3A1C7D1G2E1E4A3oa2Pe2HTPYh1RNc2E1KDc1==',
                charCounterCount: false,
                height: 200,
                placeholderText: '',
                enter: $.FroalaEditor.ENTER_P,
                toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', '|',  'html'],
                htmlAllowedTags: ['strong', 'b', 'i', 'em', 'u', 's', 'br', 'p'],

                // always clean on Word paste (not giving a choice)
                wordPasteModal: false,
                wordPasteKeepFormatting: false,
            }
        }
    },
    watch: {
        total() {
            this.setOptionPrice();
        },
        custom_mc_cd_leads() {
            this.setMcLeads('custom');
        },
        custom_mc_oo_leads() {
            this.setMcOOLeads('custom');
        },
        custom_mc_student_leads() {
            this.setMcStudentLeads('custom');
        },
        'results.discounts_250_ja'(newValue) {
            if (newValue) {
                Vue.set(this.results, 'discounts_500_ja', false);
                Vue.set(this.results, 'discounts_1000_ja', false);
            }
        },
        discounts_250_ja_allowed() {
            if (this.results) {
                if (this.discounts_250_ja_allowed) {
                    this.results.discounts_250_ja = true;
                } else {
                    this.results.discounts_250_ja = false;
                }
            }
        },
        'results.discounts_500_ja'(newValue) {
            if (newValue) {
                Vue.set(this.results, 'discounts_250_ja', false);
                Vue.set(this.results, 'discounts_1000_ja', false);
            }
        },
        discounts_500_ja_allowed() {
            if (this.results) {
                if (this.discounts_500_ja_allowed) {
                    this.results.discounts_500_ja = true;
                } else {
                    this.results.discounts_500_ja = false;
                }
            }
        },
        'results.discounts_1000_ja'(newValue) {
            if (newValue) {
                Vue.set(this.results, 'discounts_250_ja', false);
                Vue.set(this.results, 'discounts_500_ja', false);
            }
        },
        discounts_1000_ja_allowed() {
            if (this.results) {
                if (this.discounts_1000_ja_allowed) {
                    this.results.discounts_1000_ja = true;
                } else {
                    this.results.discounts_1000_ja = false;
                }
            }
        },
        totalDiscounts() {
            this.results.discount_option2 = this.totalDiscounts;
        }
    },
    computed: {
        optionLabel() {
            return "Option " + this.number + " Enabled";
        },
        mc_leads() {
            let options = _.map(this.results.mc_plans.cd, (plan) => plan.leads);
            return (options.includes(this.tab_form.mc_leads))
              ? this.tab_form.mc_leads
              : 'custom';
        },
        mc_lead_price() {
          let prices = _.map(this.results.mc_plans.cd, (plan) => plan.price);
          return prices[0];
        },
        mc_oo_leads() {
          let options = _.map(this.results.mc_plans.oo, (plan) => plan.leads);
          return (options.includes(this.tab_form.mc_oo_leads))
              ? this.tab_form.mc_oo_leads
              : 'custom';
        },
        mc_oo_lead_price() {
          let prices = _.map(this.results.mc_plans.oo, (plan) => plan.price);
          return prices[0];
        },
        mc_student_leads() {
          let options = _.map(this.results.mc_plans.student, (plan) => plan.leads);
          return (options.includes(this.tab_form.mc_student_leads))
              ? this.tab_form.mc_student_leads
              : 'custom';
        },
        mc_student_lead_price() {
          let prices = _.map(this.results.mc_plans.student, (plan) => plan.price);
          return prices[0];
        },
        discounts_250_ja_allowed() {
            const totalBudget = this.totalDriverBoost + this.totalMultiCarrier;

            const dejaLeadsInBoundaries = this.allDejaLeads > 0 && this.allDejaLeads < 25;
            const budgetInBoundaries = totalBudget > 0 && totalBudget < 2500;

            return dejaLeadsInBoundaries && budgetInBoundaries;
        },
        discounts_500_ja_allowed() {
            const totalBudget = this.totalDriverBoost + this.totalMultiCarrier;

            const dejaLeadsInBoundaries = this.allDejaLeads >= 25 && this.allDejaLeads < 50;
            const budgetInBoundaries = totalBudget > 0 && totalBudget < 2500;

            return dejaLeadsInBoundaries && budgetInBoundaries;
        },
        discounts_1000_ja_allowed() {
            const totalBudget = this.totalDriverBoost + this.totalMultiCarrier;

            const dejaLeadsInBoundaries = this.allDejaLeads >= 50;
            const budgetInBoundaries = this.totalMultiCarrier > 0 && totalBudget > 2500;

            return dejaLeadsInBoundaries || budgetInBoundaries;
        },
        allDejaLeads() {
            if (this.tab_form.equipment_based_plans) {
                return _.sum(_.map(this.tab_form.equipment_based_plans, (plan) => plan.leads));
            }
            return 0;
        },
        allMcLeads() {
            return this.tab_form.mc_leads + this.tab_form.mc_oo_leads + this.tab_form.mc_student_leads;
        },
        hireEstimate() {
            return this.allDejaLeads / 50;
        },
        totalDriverBoost() {
            if (this.tab_form.equipment_based_plans) {
                return _.sum(_.map(this.tab_form.equipment_based_plans, (plan) => plan.leads * plan.price));
            }
            return 0;
        },
        totalMultiCarrier() {
            return  this.tab_form.mc_leads * this.mc_lead_price
                + this.tab_form.mc_oo_leads * this.mc_oo_lead_price
                + this.tab_form.mc_student_leads * this.mc_student_lead_price
        },
        totalDiscounts() {
            return (this.tab_form.discounts_250_ja ? 250 : 0)
            + (this.tab_form.discounts_500_ja ? 500 : 0)
            + (this.tab_form.discounts_1000_ja ? 1000 : 0);
        },
        total() {
            let discounts = (this.tab_form.discounts_250_ja ? 250 : 0)
                + (this.tab_form.discounts_500_ja ? 500 : 0)
                + (this.tab_form.discounts_1000_ja ? 1000 : 0);

            let defaultBudget = 1000;
            let customBudget = this.tab_form.custom_budget || 0;

            let budget = parseInt(this.tab_form.is_custom_budget_active ? customBudget : defaultBudget);

            return budget + this.totalMultiCarrier + this.totalDriverBoost - discounts;
        }
    },
    methods: {
        setOptionPrice() {
            this.tab_form.price = this.total;
        },
        setMcLeads(value) {
            if (value == 'custom') {
                this.tab_form.mc_leads = parseInt(this.custom_mc_cd_leads) || 0;
            }
            else {
                this.tab_form.mc_leads = value;
            }
        },
        setMcOOLeads(value) {
          if (value == 'custom') {
            this.tab_form.mc_oo_leads = parseInt(this.custom_mc_oo_leads) || 0;
          }
          else {
            this.tab_form.mc_oo_leads = value;
          }
        },
        setMcStudentLeads(value) {
          if (value == 'custom') {
            this.tab_form.mc_student_leads = parseInt(this.custom_mc_student_leads) || 0;
          }
          else {
            this.tab_form.mc_student_leads = value;
          }
        },
        leadsPlanName(leads, price) {
            return leads ? leads+' leads (+'+this.money(leads * price, 0)+')' : 'no Driver Boost';
        },
    }
}
</script>
